<main class="container">
	<div class="articles">
		<div class="breadcrumbs"></div>

		<div class="headers" [permission]="Permissions.GeneralAccess">
			<ng-container *ngIf="headerArticles?.length">
				<!--<div class="header-article-content" *ngIf="headerArticles[activeHeader] as article">-->
				<div class="header-article-content" *ngIf="headerArticles[galleriaActiveIndex] as article">

					<div class="article-word">{{ article.word }}</div>



					<div class="galleria-wrapper">
						<p-galleria #galleria
												[value]="galleriaImages"
												[responsiveOptions]="responsiveOptions"
												[showThumbnails]="false"
												[showIndicators]="false"
												[(activeIndex)]="galleriaActiveIndex"
												[circular]="true"
												containerStyleClass="custom-galleria"
												[autoPlay]="true"
												[transitionInterval]="9700"
												[numVisible]="1"
												[showItemNavigators]="true"
												[showItemNavigatorsOnHover]="false"
												[showIndicatorsOnItem]="true"
												[style]="{ 'max-width': '100%', 'margin': '0 auto' }">

							<ng-template pTemplate="item" let-item let-index="index">
								<img [src]="item.previewImageSrc"
										 [alt]="item.alt"
										 (click)="goToArticle(item.articleRef)" />
							</ng-template>

							<!-- Footer with arrows + indicators -->
							<ng-template pTemplate="footer">
								<div class="galleria-footer-bar">
									<button (click)="galleriaActiveIndex = (galleriaActiveIndex - 1 + galleriaImages.length) % galleriaImages.length">
										<i class="pi pi-chevron-left"></i>
									</button>

									<div class="galleria-footer-indicators">
										<button *ngFor="let item of galleriaImages; let i = index"
														[class.active]="i === galleriaActiveIndex"
														(click)="galleriaActiveIndex = i">
										</button>
									</div>

									<button (click)="galleriaActiveIndex = (galleriaActiveIndex + 1) % galleriaImages.length">
										<i class="pi pi-chevron-right"></i>
									</button>
								</div>
							</ng-template>



						</p-galleria>



					</div>





					<!-- TEXT CONTENT -->
					<div class="info">

						<h2><a (click)="goToArticle(article)">{{ article.articleName }}</a></h2>

						<p>
							{{ article.excerpt }}
							&nbsp;
							<a class="read-more" (click)="goToArticle(article)">Read More</a>
						</p>

						<div class="social-activity" [permission]="Permissions.Comments">
							<div class="likes" *ngIf="article.enableLikes">
								<mat-icon>thumb_up</mat-icon>{{ article.likeCount }} Likes
							</div>

							<div class="comments" *ngIf="article.enableComments">
								<mat-icon>forum</mat-icon>{{ article.commentCount }} Comments
							</div>

							<div class="views">
								<mat-icon>visibility</mat-icon>
								{{ article.views }} View{{ article.views == 1 ? '' : 's' }}
							</div>
						</div>

					</div>
				</div>
			</ng-container>
		</div>



		<ul [permission]="Permissions.GeneralAccess">
			<p-carousel [value]="featureArticles" [numVisible]="visibleFeatureCount" [numScroll]="1" [showIndicators]="false">
				<ng-template pTemplate="item" let-article>
					<app-landing-article-tile [article]="article"></app-landing-article-tile>
				</ng-template>
			</p-carousel>
		</ul>


	</div>

	<div class="forum" [permission]="Permissions.Forums">

		<div class="card">
			<h1><i class="pi pi-comments mr-2 text-primary"></i>Forum</h1>
			<app-recent-forum-posts [count]="4"></app-recent-forum-posts>
		</div>

	</div>
	<div class="new-products" [permission]="Permissions.GeneralAccess">
		<div class="heading">
			<h1><i class="pi pi-box mr-2 text-primary"></i>New Arrivals</h1>
			<div class="see-all-new"><a [routerLink]="['/warehouse', 'new']">Show New Arrivals &rarr; </a></div>
		</div>
		<div class="products-container">
			<div class="product" *ngFor="let product of newProducts"><app-product-tile [product]="product"></app-product-tile></div>
		</div>
	</div>
	<div class="vendors" *ngIf="featuredVendors" [permission]="Permissions.GeneralAccess">
		<ul>
			<li *ngFor="let vendor of featuredVendors">
				<a [routerLink]="['/vendor', vendor.slug]"><img *ngIf="vendor.VendorImage" src="{{vendor.VendorImage[0].url}}"></a>
			</li>
		</ul>
	</div>
	<div class="rebates" *ngIf="instantRebateGroups" [permission]="Permissions.RebateRead">
		<div class="header">
			<h1><i class="pi pi-gift mr-2 text-primary"></i>Rebates</h1>
			<div class="rebate-button">
				<a [routerLink]="['/dashboard', 'rebate-claim']">
					<i class="pi pi-bolt mr-2"></i> Instant Rebates
				</a>
			</div>
		</div>
		<app-instant-rebate-groups [instantRebateGroups]="instantRebateGroups"></app-instant-rebate-groups>
	</div>
</main>
